import React from 'react';
import './CommentSection.scss';

interface CommentSectionProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  required?: boolean;
}

const CommentSection: React.FC<CommentSectionProps> = ({
  label = 'Comment',
  value,
  onChange,
  placeholder = 'Enter comment',
  error,
  required = false,
}) => {
  return (
    <div className='comment-section'>
      <div className='comment-container'>
        <div className='comment-field'>
          <label htmlFor='comment' className='comment-label'>
            {label} {required && <span className={`required-indicator  ${error ? 'error' : ''}`}>*</span>}
          </label>
          <textarea
            id='comment'
            name='comment'
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className={`comment-textarea ${error ? 'error-border' : ''}`}
          />
          {error && <div className='error-messages'>{error}</div>}
        </div>
      </div>
    </div>
  );
};

export default CommentSection;
